import api from "./api";

export const MAX_UPLOAD_SIZE_BYTES = 5 * 1024 * 1024;

export const ALLOWED_IMAGE_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
]);

const validateFile = (file, allowedTypes) => {
  if (!file) {
    throw new Error("Nenhum arquivo selecionado.");
  }

  if (file.size > MAX_UPLOAD_SIZE_BYTES) {
    throw new Error(`O arquivo "${file.name}" deve ter no maximo 5MB.`);
  }

  if (!allowedTypes.has(file.type)) {
    throw new Error(`Tipo de arquivo nao permitido: ${file.name}`);
  }
};

const requestPresignedUpload = async (file) => {
  const { data } = await api.post("/upload/presigned", {
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size,
  });

  if (!data?.uploadUrl || !data?.fileUrl) {
    throw new Error("Erro ao obter permissao de upload.");
  }

  return {
    uploadUrl: String(data.uploadUrl),
    fileUrl: String(data.fileUrl),
  };
};

export const uploadPresignedFile = async (
  file,
  allowedTypes = ALLOWED_IMAGE_TYPES,
) => {
  validateFile(file, allowedTypes);

  const { uploadUrl, fileUrl } = await requestPresignedUpload(file);
  const response = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type || "application/octet-stream",
    },
  });

  if (!response.ok) {
    throw new Error("Falha ao enviar arquivo para a nuvem.");
  }

  return fileUrl;
};
